module.exports = __webpack_public_path__ + "static/media/feedlogic-logo.fd369e38.jpg";